import { storageStore } from '@/helpers/storage-store';
import { createTableFiltersState } from '@/utils/table-filters';

import { AudienceFilters } from '../types';

export const useAudienceFilters = createTableFiltersState<AudienceFilters>();

type FavoriteAudienceFilters = {
  channelIds: string[];
};

export const useFavoriteAudienceFilters = storageStore<FavoriteAudienceFilters>({
  key: 'broadcastScheduleProgramAudienceFavoriteFilters',
  storage: localStorage,
  initialValue: {
    channelIds: [],
  },
});
